export function isOverflown(element) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  )
}

function getWords(name) {
  if (!name) {
    return []
  }
  name = name.trim()
  const words = name.split(' ')
  return words.filter((word) => word && !!word.trim()) // non empty words
}

export function numOfWords(name) {
  return getWords(name).length
}

const appendInCurrentLine = (line, word) => (line ? `${line} ${word}` : word)

export function breakInMultipleLines(
  name,
  maxCharactersPerLine = 14,
  maxNumOfLines = 2
) {
  if (!name) {
    return null
  }

  const words = getWords(name)

  const lines = []
  let lineIndex = 1
  let line = ''
  let wordCount = 0
  words.forEach((word) => {
    if (lineIndex === maxNumOfLines) {
      line = appendInCurrentLine(line, word)
      return
    }

    if (appendInCurrentLine(line, word).length <= maxCharactersPerLine) {
      line = appendInCurrentLine(line, word)
      wordCount++
      return
    }

    if (wordCount === 0) {
      lines.push(word)
    } else {
      lines.push(line)
      line = word
      wordCount = 1
    }
    lineIndex++
  })

  if (line) {
    lines.push(line)
  }

  return lines
}
